
import React from 'react';
import { STEPS } from '../constants';

const Process: React.FC = () => {
  return (
    <section id="process" className="py-24 bg-background-light dark:bg-background-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-16 lg:mb-20">
          <div className="max-w-xl">
            <h2 className="text-accent font-bold uppercase tracking-[0.2em] text-xs sm:text-sm mb-4">The Margate Method</h2>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-black text-dark-gray dark:text-white">Our 4-Step Process for a <br className="hidden sm:block"/>Worry-Free Roof</p>
          </div>
          <p className="text-gray-500 dark:text-gray-400 max-w-xs text-sm sm:text-base leading-relaxed">
            We follow a strict, disciplined process to ensure every project meets our gold-standard quality.
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line (Desktop Only) */}
          <div className="hidden lg:block absolute top-[28px] left-0 w-full h-[2px] bg-gray-200 dark:bg-gray-800 -z-0"></div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 relative z-10">
            {STEPS.map((step) => (
              <div key={step.id} className="group flex flex-col items-start bg-white dark:bg-gray-800/80 p-8 rounded-2xl shadow-xl lg:shadow-none lg:bg-transparent lg:p-0 transition-all duration-300 hover:translate-y-[-4px] lg:hover:translate-y-0">
                <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center font-black text-xl mb-6 shadow-lg shadow-primary/30 border-4 border-white dark:border-background-dark relative z-10">
                  {step.id}
                </div>
                <h4 className="text-xl font-bold mb-4 text-dark-gray dark:text-white">{step.title}</h4>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
